import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import config from "../../config/config";
import EmployerPageFrame from "../../components/employer/EmployerPageFrame";
import { Button } from "../../components/ui/button";

export default function StbAnzeigeVerwaltung() {
  const [anzeigen, setAnzeigen] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [hinweis, setHinweis] = useState("");
  const navigate = useNavigate();
  const userId = localStorage.getItem("userid");

  useEffect(() => {
    axios
      .get(`${config.API_BASE_URL}/api/stb/anzeigen/user/${userId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((res) => {
        if (res.data.anzeigen?.length === 0) {
          setHinweis(res.data.message);
        } else {
          setAnzeigen(res.data.anzeigen);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error("Fehler beim Laden der Anzeigen:", err);
        setError("Fehler beim Laden der Anzeigen.");
        setLoading(false);
      });
  }, [userId]);

  const handlePause = async (id) => {
    try {
      await axios.put(`${config.API_BASE_URL}/api/stb/anzeigen/${id}/pause`, {}, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      setAnzeigen((previous) => previous.map((item) => (
        item.id === id ? { ...item, status: "paused" } : item
      )));
    } catch (err) {
      console.error("Fehler beim Pausieren:", err);
      alert("Anzeige konnte nicht pausiert werden.");
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Anzeige wirklich loeschen?")) return;
    try {
      await axios.delete(`${config.API_BASE_URL}/api/stb/anzeigen/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      setAnzeigen((previous) => previous.filter((item) => item.id !== id));
    } catch (err) {
      console.error("Fehler beim Loeschen:", err);
      alert("Anzeige konnte nicht geloescht werden.");
    }
  };

  return (
    <EmployerPageFrame
      title="Legacy Anzeigen"
      subtitle="Der aeltere Kartenpfad bleibt erreichbar, wird aber visuell in dieselbe Employer-Shell gezogen und verliert seine isolierte Dark-Anmutung."
      actions={(
        <Button className="dashboard-action-button" onClick={() => navigate("/dashboard/stb/edit/new")}>
          Neue Anzeige anlegen
        </Button>
      )}
      contentClassName="space-y-4"
    >
      {loading ? <p className="text-sm text-slate-500">Lade Anzeigen...</p> : null}
      {error ? <p className="rounded-lg border border-rose-200 bg-rose-50 p-3 text-sm text-rose-700">{error}</p> : null}

      {!loading && hinweis ? (
        <section className="dashboard-card-shell text-center">
          <p className="text-lg text-slate-900">{hinweis}</p>
          <Button className="mt-3 dashboard-action-button" onClick={() => navigate("/dashboard/stb/edit/new")}>
            Neue Anzeige anlegen
          </Button>
        </section>
      ) : null}

      {!loading && !hinweis ? (
        <section className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
          {anzeigen.map((item) => (
            <article key={item.id} className="dashboard-card-shell space-y-3">
              <div className="flex items-start justify-between gap-3">
                <div>
                  <p className="text-lg font-semibold text-slate-900">{item.title}</p>
                  <p className="text-sm text-slate-500">{item.region || "-"} · {item.arbeitsform || "-"}</p>
                </div>
                <span className="rounded-full border border-slate-200 bg-slate-50 px-3 py-1 text-xs font-semibold uppercase tracking-[0.16em] text-slate-600">
                  {item.status}
                </span>
              </div>

              {item.logo_path ? (
                <img src={`${config.API_BASE_URL}${item.logo_path}`} alt="Logo" className="h-16 w-auto rounded-lg border border-slate-200 bg-white p-2" />
              ) : null}

              <div className="space-y-1 text-sm text-slate-600">
                <p><strong>Sprachniveau:</strong> {item.sprachniveau || "-"}</p>
                <p><strong>Gehalt:</strong> {item.gehalt || "-"} EUR</p>
                <p><strong>Onboarding:</strong> {item.onboarding || "-"} EUR</p>
                <p><strong>Unterkunft:</strong> {item.wohnung || "-"}</p>
                <p><strong>Einsatzort:</strong> {item.einsatzort_address || "-"}</p>
              </div>

              <p className="line-clamp-4 text-sm text-slate-600">{item.description || "-"}</p>

              <div className="flex flex-wrap gap-2">
                <Button size="sm" variant="outline" className="dashboard-inline-button" onClick={() => navigate(`/stb/preview/${item.id}`)}>
                  Vorschau
                </Button>
                <Button size="sm" variant="outline" className="dashboard-inline-button" onClick={() => navigate(`/dashboard/stb/edit/${item.id}`)}>
                  Bearbeiten
                </Button>
                <Button size="sm" className="dashboard-action-button-secondary" onClick={() => handlePause(item.id)}>
                  Pausieren
                </Button>
                <Button size="sm" className="dashboard-action-button-danger" onClick={() => handleDelete(item.id)}>
                  Loeschen
                </Button>
                <Button size="sm" variant="outline" className="dashboard-inline-button" onClick={() => navigate(`/dashboard/stb/analyse/${item.id}`)}>
                  Analyse
                </Button>
                <Button size="sm" variant="outline" className="dashboard-inline-button" onClick={() => navigate(`/dashboard/stb/translate/${item.id}`)}>
                  Translate
                </Button>
              </div>
            </article>
          ))}
        </section>
      ) : null}
    </EmployerPageFrame>
  );
}
